/**
 * User data: the per-user UI preferences (column orders, saved filters ...)
 * that ride in the session context — g.user.data. g.userData reads them
 * locally and writes them through /frm/user/data/set, which updates the
 * server-side context in the same transaction AND the local copy on
 * success, so g.user.data never goes stale.
 *
 * g.user itself (name, email, avatar, data) is set by g.init() from the
 * server-injected settings — null on public pages / anonymous visitors
 * (writes then answer the API's access-denied envelope, code 16).
 */
import { apiFetch } from './fetch.js';

export const userData = {
	// read a key from the local copy; fallback when anonymous or unset
	get(key, fallback = null) {
		const data = window.g?.user?.data;
		return data && key in data ? data[key] : fallback;
	},

	// replace ONE key server-side (null = remove it); resolves to the
	// envelope, with the local g.user.data refreshed on success
	async set(key, value = null) {
		const res = await apiFetch('/frm/user/data/set', { key, value }, { progress: false });
		if (res.success && res.error.code === 0 && window.g?.user) {
			window.g.user.data = res.data.data;
		}
		return res;
	},
};
